// extracted by mini-css-extract-plugin
export default {"cls1":"bIHSv7bj1A0kFjXItr4w","cls2":"sZLSl0YP6snHtQ6rwDpK bIHSv7bj1A0kFjXItr4w"};